<!--学术会议 新页面 -->
<template>
  <div class="meeting-list">
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已到底部"
        @load="onLoad"
    >
     <div class="meeting-list-box" v-for="(item,index) in list" :key="index" @click="go(item)">
      <div class="meeting-list-box-img">
        <img :src="item.cover_img" alt="">
        <div class="meeting-list-box-img-zl" v-if="item.origin_type == 14">
          <img v-if="item.meeting_status== 0" src="static/v4/icon_list_tag_live_count_down.svg"/>
          <img v-else-if="item.meeting_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
          <img v-else-if="item.meeting_status== 2" src="static/v4/icon_list_tag_academic_end.svg"/>
        </div>
        <div class="meeting-list-box-img-zl" v-else-if="item.origin_type == 4">
          <img v-if="item.status_text== '预告'" src="static/v4/icon_list_tag_live_count_down.svg"/>
          <img v-else-if="item.status_text== '直播中'" src="static/v4/icon_list_tag_academic_process.svg" />
          <img v-else src="static/v4/icon_list_tag_academic_end.svg"/>
        </div>
        <div class="meeting-list-box-img-zl" v-else-if="item.origin_type == 13">
          <img v-if="item.status_text== '预告'" src="static/v4/icon_list_tag_live_count_down.svg"/>
          <img v-else-if="item.status_text== '直播中'" src="static/v4/icon_list_tag_academic_process.svg" />
          <img v-else-if="item.status_text == '已结束'" src="static/v4/icon_list_tag_academic_end.svg"/>
        </div>
        <div class="meeting-list-box-img-btn" v-if="item.origin_type == 14 && item.meeting_status != 2">
          <span v-if="item.isApply" class="meeting-list-box-img-btn-span1">已报名</span>
          <span v-else class="meeting-list-box-img-btn-span2" @click.stop="goApply(item)">报名参会</span>
        </div>
<!--        <div class="meeting-list-box-img-btn" v-else-if="item.origin_type == 4 && item.live_status != 2" >-->
<!--          <span v-if="item.isAppointment" class="meeting-list-box-img-btn-span1">已报名</span>-->
<!--          <span v-else class="meeting-list-box-img-btn-span2" @click.stop="goApply(item)">报名参会</span>-->
<!--        </div>-->
      </div>
       <div class="meeting-list-box-title">
         <span>{{ item.title }}</span>
       </div>
       <div class="meeting-list-box-desc" v-if="item.origin_type == 4">
         <span v-if="item.type == 2">共{{ item.total_count }}期  <span style="margin-left: 4px">{{ item.view_count }}人观看</span></span>
         <span v-else>{{ item.start_at }}</span>
       </div>
       <div class="meeting-list-box-desc" v-if="item.origin_type == 14">
         <span>{{ item.start_at }}-{{ item.end_at }}</span>
       </div>
     </div>
    </van-list>
  </div>
</template>

<script>
import Interface from "@/util/interface"
export default {
  name: "meeting-list",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 0,
    }
  },
  created() {
      Interface.getShareInfo(this,"学术会","","探寻医学前沿，见证关键进展")
  },
  methods: {
    onLoad() {
        this.page++
        let params = {
          page: this.page,
          pageSize:10
        }
        Interface.getData('get', Interface.v4.meeting_list,params).then((res) => {
          this.list.push(...res.data.list)
          this.loading = false
          if (this.page >= res.data.total_page) {
            this.finished = true
          }
        })
    },
    go(item){
        if(item.origin_type == 14){
            Interface.goMeeting(this,{
                is_saas:item.is_saas,
                uuid:item.uuid,
                type:item.type,
            })
        }else if(item.origin_type == 4){
            Interface.goLiveDetail(this,{
                id:item.origin_id,
                type:item.type,
                live_status:item.live_status,
                isAppointment:item.isAppointment,
            })
        } else if (item.origin_type == 13) {
          this.$router.push({name: 'topic-detail', params: { id: item.origin_id }})
        }
    },
    goApply(item) {
        Interface.goMeeting(this,{
            is_saas:item.is_saas,
            uuid:item.uuid,
            type:item.type,
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index-new.scss";
</style>



// WEBPACK FOOTER //
// src/views/meeting/list/index-new.vue